module.exports = __webpack_public_path__ + "static/media/beach-2.3863abf0.jpg";